/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HttpPolicySetModule
 * @preferred
 */

import angular from 'angular';
import { initAjsDependency } from 'ajs/js/utilities/ajsDependency';

import {
    HTTPHdrActionConfigItem,
    HTTPHdrDataConfigItem,
    HTTPPolicySetCollection,
    HTTPPolicySetItem,
    HTTPRequestPolicyConfigItem,
    HTTPRequestRuleConfigItem,
    HTTPResponsePolicyConfigItem,
    HTTPResponseRuleConfigItem,
    HTTPRewriteLocHdrActionConfigItem,
    HTTPRewriteURLActionConfigItem,
    HTTPSecurityActionConfigItem,
    HTTPSecurityPolicyConfigItem,
    HTTPSecurityRuleConfigItem,
    HTTPSwitchingActionConfigItem,
} from './factories';

import {
    HTTP_HDR_ACTION_CONFIG_ITEM_TOKEN,
    HTTP_HDR_DATA_CONFIG_ITEM_TOKEN,
    HTTP_POLICY_SET_COLLECTION_TOKEN,
    HTTP_POLICY_SET_ITEM_TOKEN,
    HTTP_REQUEST_POLICY_CONFIG_ITEM_TOKEN,
    HTTP_REQUEST_RULE_CONFIG_ITEM_TOKEN,
    HTTP_RESPONSE_POLICY_CONFIG_ITEM_TOKEN,
    HTTP_RESPONSE_RULE_CONFIG_ITEM_TOKEN,
    HTTP_REWRITE_LOC_HDR_ACTION_CONFIG_ITEM_TOKEN,
    HTTP_REWRITE_URL_ACTION_CONFIG_ITEM_TOKEN,
    HTTP_SECURITY_ACTION_CONFIG_ITEM_TOKEN,
    HTTP_SECURITY_POLICY_CONFIG_ITEM_TOKEN,
    HTTP_SECURITY_RULE_CONFIG_ITEM_TOKEN,
    HTTP_SWITCHING_ACTION_CONFIG_ITEM_TOKEN,
} from './http-policy-set.tokens';

const httpPolicySetModule = angular.module('avi/http-policy-set');

const factories = [
    {
        factory: HTTPPolicySetCollection,
        name: HTTP_POLICY_SET_COLLECTION_TOKEN,
    }, {
        factory: HTTPPolicySetItem,
        name: HTTP_POLICY_SET_ITEM_TOKEN,
    }, {
        factory: HTTPSecurityPolicyConfigItem,
        name: HTTP_SECURITY_POLICY_CONFIG_ITEM_TOKEN,
    }, {
        factory: HTTPSecurityRuleConfigItem,
        name: HTTP_SECURITY_RULE_CONFIG_ITEM_TOKEN,
    }, {
        factory: HTTPSecurityActionConfigItem,
        name: HTTP_SECURITY_ACTION_CONFIG_ITEM_TOKEN,
    }, {
        factory: HTTPRequestPolicyConfigItem,
        name: HTTP_REQUEST_POLICY_CONFIG_ITEM_TOKEN,
    }, {
        factory: HTTPRequestRuleConfigItem,
        name: HTTP_REQUEST_RULE_CONFIG_ITEM_TOKEN,
    }, {
        factory: HTTPRewriteURLActionConfigItem,
        name: HTTP_REWRITE_URL_ACTION_CONFIG_ITEM_TOKEN,
    }, {
        factory: HTTPSwitchingActionConfigItem,
        name: HTTP_SWITCHING_ACTION_CONFIG_ITEM_TOKEN,
    }, {
        factory: HTTPHdrActionConfigItem,
        name: HTTP_HDR_ACTION_CONFIG_ITEM_TOKEN,
    }, {
        factory: HTTPHdrDataConfigItem,
        name: HTTP_HDR_DATA_CONFIG_ITEM_TOKEN,
    }, {
        factory: HTTPResponsePolicyConfigItem,
        name: HTTP_RESPONSE_POLICY_CONFIG_ITEM_TOKEN,
    }, {
        factory: HTTPResponseRuleConfigItem,
        name: HTTP_RESPONSE_RULE_CONFIG_ITEM_TOKEN,
    }, {
        factory: HTTPRewriteLocHdrActionConfigItem,
        name: HTTP_REWRITE_LOC_HDR_ACTION_CONFIG_ITEM_TOKEN,
    },
];

factories.forEach(({ name, factory }) => {
    initAjsDependency(httpPolicySetModule, 'factory', name, factory);
});
